import { del, get, patch, post } from './client.js';

export const getSecurityCenter  = (orgId)              => get(`/orgs/${orgId}/security-center`);
export const updateMfa          = (orgId, data)         => patch(`/orgs/${orgId}/security/mfa`, data);
export const getSessions        = (orgId)               => get(`/orgs/${orgId}/security/sessions`);
export const getIpAllowlist     = (orgId)               => get(`/orgs/${orgId}/security/ip-allowlist`);
export const addIpAllowlist     = (orgId, data)         => post(`/orgs/${orgId}/security/ip-allowlist`, data);
export const removeIpAllowlist  = (orgId, entryId)      => del(`/orgs/${orgId}/security/ip-allowlist/${entryId}`);
export const revokeSession      = (orgId, sessionId)    => del(`/orgs/${orgId}/security/sessions/${sessionId}`);
